import videojs from 'video.js';

const ClickableComponent = videojs.getComponent('ClickableComponent');
// const Button = videojs.getComponent('Button');
const Component = videojs.getComponent('Component');

const defaultOptions = {};

export default class AirPlayButton extends ClickableComponent {
	constructor(player, options) {
		super(player, options);
		this.player = player;
		this.options = videojs.mergeOptions(defaultOptions, options);

		// https://developer.apple.com/documentation/webkitjs/adding_an_airplay_button_to_your_safari_media_controls
		if (window.WebKitPlaybackTargetAvailabilityEvent) {
			this.player.tech().el_.addEventListener('webkitplaybacktargetavailabilitychanged', event => {
				this.toggleClass('vjs-airplay-button_show', event.availability === 'available');
			});
		}
	}

	handleClick() {
		this.player.tech().el_.webkitShowPlaybackTargetPicker();
	}

	createEl() {
		const el = videojs.dom.createEl('button', {
			className: 'vjs-airplay-button'
		});
		el.insertAdjacentHTML(
			'afterbegin',
			'<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.70078 2.00029C1.70078 1.83461 1.8351 1.70029 2.00078 1.70029H16.0008C16.1665 1.70029 16.3008 1.83461 16.3008 2.00029V12.0003C16.3008 12.166 16.1665 12.3003 16.0008 12.3003H13.5003V13.7003H16.0008C16.9397 13.7003 17.7008 12.9392 17.7008 12.0003V2.00029C17.7008 1.06141 16.9397 0.300293 16.0008 0.300293H2.00078C1.0619 0.300293 0.300781 1.06141 0.300781 2.00029V12.0003C0.300781 12.9392 1.0619 13.7003 2.00078 13.7003H4.50029V12.3003H2.00078C1.8351 12.3003 1.70078 12.166 1.70078 12.0003V2.00029ZM6.20662 16.2999L9.00039 11.4108L11.7942 16.2999H6.20662ZM9.95546 10.2604C9.53317 9.52138 8.46761 9.52138 8.04532 10.2604L4.73459 16.0541C4.31555 16.7875 4.84506 17.6999 5.68966 17.6999H12.3111C13.1557 17.6999 13.6852 16.7875 13.2662 16.0541L9.95546 10.2604Z" fill="white"/></svg>'
		);
		return el;
	}
}

Component.registerComponent('AirPlayButton', AirPlayButton);
